import { useCallback, useMemo } from 'react'
import { useAppSelector } from './useAppSelector'
import {
    API_DATE_FORMAT,
    DISPLAY_DATE_FORMAT,
    formatLocalTimeFromUtc as formatLocalTimeFromUtcInZone,
    formatUtcTimeFromLocal as formatUtcTimeFromLocalInZone,
    fromPickerDate as fromPickerDateInZone,
    resolveTimezone,
    toPickerDate as toPickerDateInZone
} from '../utils/timezone'

export const useTimezone = () => {
    const t = useAppSelector(state => state.userPreference?.data?.timezone)

    const timezone = useMemo(() => resolveTimezone(t?.val), [t?.val])

    const formatUtcTimeFromLocal = useCallback((
        date: string | Date | null | undefined,
        format = API_DATE_FORMAT
    ): string | null => formatUtcTimeFromLocalInZone(date, timezone, format), [timezone])

    const formatLocalTimeFromUtc = useCallback((
        date: string | Date | null | undefined,
        format = DISPLAY_DATE_FORMAT
    ): string | null => formatLocalTimeFromUtcInZone(date, timezone, format), [timezone])

    const toPickerDate = useCallback((
        date: string | Date | null | undefined
    ): Date | null => toPickerDateInZone(date, timezone), [timezone])

    const fromPickerDate = useCallback((
        date: Date | null | undefined
    ): Date | null => fromPickerDateInZone(date, timezone), [timezone])

    return { timezone, formatUtcTimeFromLocal, formatLocalTimeFromUtc, toPickerDate, fromPickerDate }
}
